"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var formatStatValue = function (value) {
    if (value >= 1000000) {
        return "".concat((value / 1000000).toFixed(1), "M");
    }
    else if (value >= 1000) {
        return "".concat((value / 1000).toFixed(1), "K");
    }
    return value.toLocaleString();
};
var describeRank = function (rank) {
    if (!rank)
        return (0, jsx_runtime_1.jsx)("span", { className: "text-muted", children: "N/A" });
    if (rank.rank === null)
        return (0, jsx_runtime_1.jsx)("span", { className: "text-muted", children: "Unranked" });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "font-semibold text-default-foreground", children: ["#", rank.rank.toLocaleString()] }), (0, jsx_runtime_1.jsxs)("span", { className: "text-muted", children: [" of ", rank.players.toLocaleString()] })] }));
};
function useRenderCellViews() {
    var renderCellViews = (0, react_1.useCallback)(function (statistic, rank) {
        return [
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm font-medium text-default-foreground", children: statistic.name }) },
            { key: "value", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm font-semibold text-primary", children: formatStatValue(statistic.value) }) },
            { key: "rank", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm", children: describeRank(rank) }) },
            { key: "version", content: (0, jsx_runtime_1.jsxs)("div", { className: "text-sm text-muted", children: ["v", statistic.version] }) },
        ];
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
